'use client';

import {
  faCircleCheck,
  faCircleInfo,
  faOctagonXmark,
  faSpinnerThird,
  faTriangleExclamation,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme='light'
      className='toaster group'
      icons={{
        success: <FontAwesomeIcon icon={faCircleCheck} className='h-4 w-4' />,
        info: <FontAwesomeIcon icon={faCircleInfo} className='h-4 w-4' />,
        warning: <FontAwesomeIcon icon={faTriangleExclamation} className='h-4 w-4' />,
        error: <FontAwesomeIcon icon={faOctagonXmark} className='h-4 w-4' />,
        loading: <FontAwesomeIcon icon={faSpinnerThird} className='h-4 w-4 animate-spin' />,
      }}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
